import { useCallback, useEffect, useRef, useState } from 'react';
import './SideNavContainer.scss';
import { useDispatch, useSelector } from 'react-redux';
import { selectSidebarOpen, toggleSidebar } from 'common/store/slices/layout.slice';
import SideNavHeader from './SideNavHeader';
import SideNavTray from './SideNavTray';
import { MenuItem } from 'common/models/page-config.models';
import SideNavContent from './SideNavContent';
import { useResize } from 'common/hooks/resize';

interface SideNavContainerProps {
  closeSidebar?: () => void;
}

function SideNavContainer({ closeSidebar }: SideNavContainerProps) {
  const { isTabletOrMobile } = useResize();
  const [expanded, setExpanded] = useState<string>('');
  const [trayContent, setTrayContent] = useState<MenuItem[]>([]);
  const dispatch = useDispatch();
  const sideNavContainerRef = useRef<HTMLDivElement>(null);
  const isSidebarOpen = useSelector(selectSidebarOpen);

  const mouseEnterHandler = useCallback(() => {
    dispatch(toggleSidebar(true));
  }, [dispatch]);

  const mouseLeaveHandler = useCallback(() => {
    dispatch(toggleSidebar(false));
    setExpanded('');

    setTimeout(() => {
      setTrayContent([]);
    }, 0);
  }, [dispatch]);

  useEffect(() => {
    const sideNavContainer = sideNavContainerRef.current;

    sideNavContainer?.addEventListener('mouseenter', mouseEnterHandler);
    sideNavContainer?.addEventListener('mouseleave', mouseLeaveHandler);

    return () => {
      sideNavContainer?.removeEventListener('mouseenter', mouseEnterHandler);
      sideNavContainer?.removeEventListener('mouseleave', mouseLeaveHandler);
    };
  }, [mouseEnterHandler, mouseLeaveHandler]);

  return (
    <div
      ref={sideNavContainerRef}
      className={`side-nav-container ${isTabletOrMobile || isSidebarOpen ? 'open' : ''}`}
    >
      <div className="side-nav-body">
        <SideNavHeader />
        <SideNavContent
          expanded={expanded}
          setExpanded={setExpanded}
          isSidebarOpen={isTabletOrMobile || isSidebarOpen}
          trayContent={trayContent}
          setTrayContent={setTrayContent}
          closeSidebar={closeSidebar}
        />
      </div>
      {trayContent.length > 0 && <SideNavTray closeSidebar={closeSidebar} items={trayContent} />}
    </div>
  );
}

export default SideNavContainer;
